









  import { Vue } from 'division-marker';
  import { Component, Prop, Watch, SaitenState, ConstsState, DmShareds, Modal } from 'saiten-base';

  import format from 'date-fns/format'

@Component({components: {}, mixins:[]})
export default class StudyAnswerImage extends Vue {
  @Prop() private sheet_activity_id!: string;
  get state():SaitenState{return this.$store.state.saiten;}
  get consts():ConstsState{return this.$store.state.consts;}
  updated_at = ''
  sheet_activity: any | null = null
  sheet: any | null = null

async mounted(){
    const res = await DmShareds.Http.get(`./api/study/sheet_activities/${this.sheet_activity_id}`)
    console.log(res.data);
    this.updated_at = format(res.data.updated_at, 'YYYYMMDD-HHmmSS')
    this.sheet_activity = res.data;
    this.sheet = res.data.sheet
  }
  back(){
    history.back()
  }
}
